// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8247":"61ffe214","8759":"ad45b95f","9907":"61ffe214"}[chunkId] + ".chunk.css";
};